var _rect, _path, _circle, _rect2, _circle2, _rect3, _rect4, _circle3, _path2, _circle4, _rect5, _rect6, _circle5, _path3, _circle6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _rect17, _circle7, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatAttendance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 36,
    width: 214,
    height: 176,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 52a16 16 0 0 1 16-16h182a16 16 0 0 1 16 16v12H26z",
    fill: "#E9F0FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 50,
    r: 5,
    fill: "#4A7CFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 46,
    width: 74,
    height: 8,
    rx: 4,
    fill: "#BCD0FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 92,
    r: 12,
    fill: "#E9F0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 84,
    width: 78,
    height: 7,
    rx: 3.5,
    fill: "#E5E8EE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 50,
    height: 6,
    rx: 3,
    fill: "#EEF1F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 92,
    r: 12,
    fill: "#E9F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209 92l3.5 3.5 6-7",
    stroke: "#4A7CFE",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 130,
    r: 12,
    fill: "#E9F0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 122,
    width: 64,
    height: 7,
    rx: 3.5,
    fill: "#E5E8EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 134,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#EEF1F5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 130,
    r: 12,
    fill: "#E9F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209 130l3.5 3.5 6-7",
    stroke: "#4A7CFE",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 172,
    r: 12,
    fill: "#E9F0FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 164,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#E5E8EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 176,
    width: 46,
    height: 6,
    rx: 3,
    fill: "#EEF1F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 160,
    width: 52,
    height: 24,
    rx: 12,
    fill: "#4A7CFE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 169,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#FFFFFF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 66,
    width: 70,
    height: 70,
    rx: 15,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 78,
    width: 16,
    height: 16,
    rx: 3,
    fill: "none",
    stroke: "#4A7CFE",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 78,
    width: 16,
    height: 16,
    rx: 3,
    fill: "none",
    stroke: "#4A7CFE",
    strokeWidth: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 108,
    width: 16,
    height: 16,
    rx: 3,
    fill: "none",
    stroke: "#4A7CFE",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 113,
    width: 6,
    height: 6,
    rx: 1.5,
    fill: "#4A7CFE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 283,
    y: 123,
    width: 6,
    height: 6,
    rx: 1.5,
    fill: "#C9DBFF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 113,
    width: 6,
    height: 6,
    rx: 1.5,
    fill: "#C9DBFF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 182,
    width: 108,
    height: 32,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222 198l16-6-6 16-3-7z",
    fill: "#4A7CFE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 195,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E5E8EE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 198,
    r: 8,
    fill: "#E9F0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 198l2.5 2.5 4.5-5",
    stroke: "#4A7CFE",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatAttendance);
export default __webpack_public_path__ + "static/media/feat-attendance.9e27c93328f0889ad22bb9037dc36304.svg";
export { ForwardRef as ReactComponent };